import AnswerBlank from './AnswerBlank';
import { WORKSHEET_CLASSES } from '../../constants/classNames';

/**
 * Numbered questions with a writing line under each one.
 */
export default function WorksheetQuestions({ questions, showAnswers, title = 'Questions' }) {
  return (
    <section className={WORKSHEET_CLASSES.part}>
      <h2 className={WORKSHEET_CLASSES.partTitle}>{title}</h2>
      <ol className={WORKSHEET_CLASSES.questions}>
        {questions.map(({ question, answer }) => (
          <li key={question} className={WORKSHEET_CLASSES.question}>
            <p>{question}</p>
            <AnswerBlank answer={answer} showAnswer={showAnswers} isWide />
          </li>
        ))}
      </ol>
    </section>
  );
}
